import React from "react";

interface EmojiPickerProps {
    onSelectEmoji: (emoji: string) => void;
}

const emojis = [
    "👏",
    "👌",
    "🤝",
    "💗",
    "❤️",
    "💔",
    "💯",
    "🌹",
    "🥀",
    "🎉",
    "🀄",
    "🌚",
    "🌝",
    "⚡",
    "🔥",
    "🉑",
    "🆗",
    "😀",
    "😃",
    "😄",
    "😁",
    "😆",
    "😅",
    "🤣",
    "😂",
    "🙂",
    "🙃",
    "😉",
    "😊",
    "😇",
    "🥰",
    "😍",
    "🤩",
    "😘",
    "😗",
    "😚",
    "😙",
    "😋",
    "😛",
    "😜",
    "🤪",
    "😝",
    "🤑",
    "🤗",
    "🤭",
    "🤫",
    "🤔",
    "🤐",
    "🤨",
    "😐",
    "😑",
    "😶",
    "😏",
    "😒",
    "🙄",
    "😬",
    "🤥",
    "😌",
    "😔",
    "😪",
    "🤤",
    "😴",
    "😷",
    "🤒",
    "🤕",
    "🤢",
    "🤮",
    "🤧",
    "🥵",
    "🥶",
    "🥴",
    "😵",
    "🤯",
    "🤠",
    "🥳",
    "😎",
    "🤓",
    "🧐",
    "😕",
    "😟",
    "🙁",
    "☹️",
    "😮",
    "😯",
    "😲",
    "😳",
    "🥺",
    "😦",
    "😧",
    "😨",
    "😰",
    "😥",
    "😢",
    "😭",
    "😱",
    "😖",
    "😣",
    "😞",
    "😓",
    "😩",
    "😫",
    "😤",
    "😡",
    "😠",
    "🤬",
    "😈",
    "👿",
    "💀",
    "☠️",
    "💩",
    "🤡",
    "👹",
    "👺",
    "👻",
    "👽",
    "👾",
    "🤖",
];

const EmojiPicker: React.FC<EmojiPickerProps> = ({ onSelectEmoji }) => {
    return (
        <div className="custom-emoji-picker">
            {emojis.map((emoji, index) => (
                <div key={index} className="custom-emoji-item" onClick={() => onSelectEmoji(emoji)}>
                    {emoji}
                </div>
            ))}
        </div>
    );
};

export default EmojiPicker;
